import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Blamable               from '@/models/traits/Blamable';
import FondationsServiceModel from '@/models/FondationsServiceModel';

@model.cacheDuration()
@model.urnResource('entity_type')
@doc.path('/entity_types/{?id}')
export default class EntityTypeModel extends Blamable(TimestampAble(FondationsServiceModel)) {
	private declare _tsFilters: {
		'id': id;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
}
